var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { ThemeProvider } from 'styled-components';
import StyledRadio from './StyledRadio';
import { validateLabelPositionPreset } from '../../utils/presetValidator';
import '../../css/clydeRadio.css';
var ClydeRadio = function (props) {
    var buttonColor = props.buttonColor, className = props.className, disabled = props.disabled, greyLabel = props.greyLabel, hidden = props.hidden, id = props.id, label = props.label, labelPosition = props.labelPosition, name = props.name, onChange = props.onChange, readonly = props.readonly, scale = props.scale, rest = __rest(props, ["buttonColor", "className", "disabled", "greyLabel", "hidden", "id", "label", "labelPosition", "name", "onChange", "readonly", "scale"]);
    var theme = {
        buttonColor: buttonColor || '#000',
        scale: scale || '',
    };
    var _changeHandler = function (e) {
        e.stopPropagation();
        if (!disabled && !hidden && !readonly) {
            onChange(e);
        }
    };
    var _labelOnClick = function (e) {
        e.preventDefault(); // Prevents focusing of radio button when label is clicked
        var processedEvent = __assign({}, e);
        processedEvent.target.name = name;
        _changeHandler(e);
    };
    if (buttonColor !== undefined && CSS.supports('color', buttonColor)) {
        theme.buttonColor = buttonColor;
    }
    var _labelPosition = 'right'; // Default position
    if (labelPosition !== undefined && validateLabelPositionPreset(labelPosition)) {
        _labelPosition = labelPosition;
    }
    var _containerClassName = classNames('clyde-radio', "clyde-radio-".concat(_labelPosition), className, {
        'clyde-radio--disabled': disabled,
        'clyde-radio--hidden': hidden,
    });
    var _labelClassName = classNames('clyde-radio-label', {
        'clyde-radio-label--grey': greyLabel,
    });
    return (React.createElement("div", { className: _containerClassName, "data-test": "radioItem-".concat(id) },
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(StyledRadio, __assign({ id: id || '', className: 'clyde-radio-button', onChange: _changeHandler, onMouseUp: function (e) { e.currentTarget.blur(); }, type: 'radio', name: name }, rest)),
            label
                && React.createElement("label", { className: _labelClassName, htmlFor: id || '', onClick: _labelOnClick }, label))));
};
export default ClydeRadio;
